// 260703nrai: Gmail-style inbox list + detail pane
function messagesInboxTabShowLoading(tabKey) {
  $(`#messages_inbox_panel_${tabKey}_loading`).show();
  $(`#messages_inbox_panel_${tabKey}_content`).hide();
}

function messagesInboxTabHideLoading(tabKey) {
  $(`#messages_inbox_panel_${tabKey}_loading`).hide();
  $(`#messages_inbox_panel_${tabKey}_content`).show();
}

function messagesInboxShowInlineLoading(loadingEl, contentEl) {
  if (loadingEl) loadingEl.style.display = '';
  if (contentEl) contentEl.style.display = 'none';
}

function messagesInboxHideInlineLoading(loadingEl, contentEl) {
  if (loadingEl) loadingEl.style.display = 'none';
  if (contentEl) contentEl.style.display = '';
}

function messagesInboxExtractListHtml(html) {
  const template = document.createElement('div');
  template.innerHTML = html;
  const meta = template.querySelector('.messages-inbox-list-meta');
  const info = meta
    ? { hasMore: meta.dataset.hasMore === '1', page: parseInt(meta.dataset.page, 10) || 1 }
    : null;
  if (meta) meta.remove();
  return { html: template.innerHTML, info };
}

function messagesInboxUpdateLoadMore(root, info) {
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  if (!listPanel) return;

  let wrap = root.querySelector('.messages-inbox-load-more-wrap');
  if (!info || !info.hasMore) {
    wrap?.remove();
    return;
  }

  if (!wrap) {
    wrap = document.createElement('div');
    wrap.className = 'messages-inbox-load-more-wrap';
    wrap.innerHTML = '<a href="#" class="clickable_text messages-inbox-load-more">Weitere laden</a>';
    listPanel.parentElement.appendChild(wrap);
  }

  const loadMoreLink = wrap.querySelector('.messages-inbox-load-more');
  loadMoreLink.dataset.page = String(info.page + 1);
}

function messagesInboxBuildListParams(root, searchForm, page) {
  const params = new URLSearchParams(new FormData(searchForm));
  params.set('page', String(page || 1));
  return params;
}

function initMessagesInbox(root) {
  if (root && !root.matches?.('[data-messages-inbox]')) {
    root = root.querySelector?.('[data-messages-inbox]') || root;
  }
  root = root || document.querySelector('[data-messages-inbox]');
  if (!root) return;

  const detailPanel = root.querySelector('[data-messages-inbox-detail]');
  const listPanel = root.querySelector('[data-messages-inbox-list]');
  const detailLoading = root.querySelector('[data-messages-inbox-detail-loading]');
  const listLoading = root.querySelector('[data-messages-inbox-list-loading]');
  if (!detailPanel || !listPanel) return;

  const selectedId = root.dataset.selectedId;
  const inboxTab = root.dataset.inboxTab;
  const searchForm = root.querySelector('.messages-inbox-search-form');
  const searchInput = root.querySelector('.messages-inbox-search-input');
  let searchDebounceTimer = null;

  function loadPreview(url, row) {
    if (!detailPanel || !url) return;

    messagesInboxShowInlineLoading(detailLoading, detailPanel);

    fetch(url, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.text())
      .then((html) => {
        detailPanel.innerHTML = html;
        listPanel.querySelectorAll('.messages-inbox-row.selected').forEach((element) => element.classList.remove('selected'));
        if (row) row.classList.add('selected');
        if (row && row.classList.contains('unread')) {
          row.classList.remove('unread');
        }
      })
      .catch(() => {
        detailPanel.innerHTML = '<p class="smallinfo">Nachricht konnte nicht geladen werden.</p>';
      })
      .finally(() => {
        messagesInboxHideInlineLoading(detailLoading, detailPanel);
      });
  }

  function runSearch() {
    if (!searchForm) return;

    const params = messagesInboxBuildListParams(root, searchForm, 1);
    messagesInboxShowInlineLoading(listLoading, listPanel);

    fetch(`/messages/inbox/list?${params.toString()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
      .then((response) => response.text())
      .then((html) => {
        const extracted = messagesInboxExtractListHtml(html);
        listPanel.innerHTML = extracted.html;
        messagesInboxUpdateLoadMore(root, extracted.info);
        history.replaceState(null, '', `${searchForm.action}?${params.toString()}`);
      })
      .finally(() => {
        messagesInboxHideInlineLoading(listLoading, listPanel);
      });
  }

  if (listPanel.dataset.bound !== '1') {
    listPanel.dataset.bound = '1';
    listPanel.addEventListener('click', function (event) {
      const row = event.target.closest('.messages-inbox-row');
      if (!row) return;
      event.preventDefault();
      loadPreview(row.dataset.previewUrl, row);
    });
  }

  root.querySelectorAll('.messages-inbox-filters .clickable_text').forEach((link) => {
    link.addEventListener('click', () => messagesInboxTabShowLoading(inboxTab));
  });

  if (searchForm && searchInput && searchForm.dataset.bound !== '1') {
    searchForm.dataset.bound = '1';
    searchForm.addEventListener('submit', function (event) {
      event.preventDefault();
      runSearch();
    });
    searchInput.addEventListener('input', function () {
      clearTimeout(searchDebounceTimer);
      searchDebounceTimer = setTimeout(runSearch, 300);
    });
  }

  if (root.dataset.loadMoreBound !== '1') {
    root.dataset.loadMoreBound = '1';
    root.addEventListener('click', function (event) {
      const loadMoreLink = event.target.closest('.messages-inbox-load-more');
      if (!loadMoreLink || !searchForm) return;
      event.preventDefault();

      const page = loadMoreLink.dataset.page;
      const params = messagesInboxBuildListParams(root, searchForm, page);
      if (root.dataset.unreadOnly === 'true') {
        params.set('unread_only', 'true');
      }

      messagesInboxShowInlineLoading(listLoading, listPanel);

      fetch(`/messages/inbox/list?${params.toString()}`, { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
        .then((response) => response.text())
        .then((html) => {
          const extracted = messagesInboxExtractListHtml(html);
          listPanel.insertAdjacentHTML('beforeend', extracted.html);
          messagesInboxUpdateLoadMore(root, extracted.info);
        })
        .finally(() => {
          messagesInboxHideInlineLoading(listLoading, listPanel);
        });
    });
  }

  if (selectedId) {
    const row = listPanel.querySelector(`.messages-inbox-row[data-message-id="${selectedId}"]`);
    if (row) {
      loadPreview(row.dataset.previewUrl, row);
    } else {
      const firstRow = listPanel.querySelector('.messages-inbox-row');
      if (firstRow) loadPreview(firstRow.dataset.previewUrl, firstRow);
    }
  } else {
    const firstRow = listPanel.querySelector('.messages-inbox-row');
    if (firstRow) loadPreview(firstRow.dataset.previewUrl, firstRow);
  }
}

window.initMessagesInbox = initMessagesInbox;
window.messagesInboxTabShowLoading = messagesInboxTabShowLoading;
window.messagesInboxTabHideLoading = messagesInboxTabHideLoading;

export { initMessagesInbox, messagesInboxTabShowLoading, messagesInboxTabHideLoading };
